// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ba49554","239":"4fcf2f63","453":"443ec042","732":"25cb3a09"}[chunkId] + ".chunk.js";
};